import React, { useState,useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
// import Feedback from "react-bootstrap/esm/Feedback";
import {Feedback} from "../../../redux/actions/AuthAction"
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import FeedbackComp from "../components/FeedbackComp";
function FeedbackModal(props) {

    const User = useSelector((state) => state.UserReducer.user);

    const [openSnackbar, closeSnackbar] = useSnackbar();
    const dispatch = useDispatch();
    const [rating,setRating] = useState("")
    const [feedback,setFeedback] = useState("")
    const [loder, setLoder] = useState(false);

    const submitFeedback = (e) =>{
        e.preventDefault();
        
        setLoder(true)

        if(!feedback && !rating){
          openSnackbar("Please fill all fields");
          setLoder(false);
        }
        else if(rating>5 || rating<1){
          openSnackbar("Please enter a valid rating");
          setLoder(false);
        }
        else{
        const data = {
          userID:User._id,
          userfeedback:feedback,
          rating:rating.toString()
        }
        const onSuccess = () =>{
          props.onHide()
          openSnackbar("Feedback submited successfully");
          setLoder(false)
        }
        const onError = () =>{
          props.onHide()
          openSnackbar("Somthing went wrong !!");
          setLoder(false)
        }
        dispatch(Feedback(data,onSuccess,onError))
      }
      }

  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // className="feedback"
      >
        <Modal.Body>
          <FeedbackComp/>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default FeedbackModal;
